angular.module('unergie.main')
.controller('affectationModalCtrl', ($scope, $filter, $uibModalInstance, user, affectedAccounts, DataAccess, AlertManager, BoFeaturesService, ErrorCatcher) => {
    $scope.search = {
        name: undefined,
    }

    $scope.changeSearchSelected = () => {
        if ($scope.searchSelected) {
            $scope.search.selected = true
        } else {
            delete $scope.search.selected
        }
    }

    $scope.crossOrg = BoFeaturesService.isFeatureOn('crossOrg')
    $scope.user = user
    $scope.recapAffectation = {}

    $scope.affectedAccounts = _.cloneDeep(affectedAccounts)

    _.each($scope.affectedAccounts, (a) => {
        a.name = `${a.name}${$scope.crossOrg ? ` (${a.organization})` : ''}`
    })


    const getFiltered = () => {
        return $filter('filter')($scope.affectedAccounts, $scope.search)
    }

    let refAffectations

    $scope.fetchingUserAffectation = true
    DataAccess.getUserAffectations({ id_account: user.id }).$promise.then((affectations) => {
        _.each($scope.affectedAccounts, (aff) => {
            if (_.find(affectations, { affected_account_id: aff.id_account })) {
                aff.selected = true
            } else {
                aff.selected = false
            }
            refAffectations = _.cloneDeep($scope.affectedAccounts)
        })
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $scope.fetchingUserAffectation = false
    })

    $scope.getDiff = () => {
        return _.filter($scope.affectedAccounts, (a) => {
            const found = _.find(refAffectations, { id_account: a.id_account })
            return found && found.selected !== a.selected
        })
    }

    $scope.generateRecapAffectation = function () {
        const grouped = _.groupBy($scope.getDiff(), 'selected')
        let list = ''
        let label = `Êtes-vous sûr de vouloir `
        if (grouped.true) {
            label += `ajouter ${grouped.true.length} affectation(s) `
            _.each(grouped.true, (t) => (list += `<li><span class="fa fa-${t.selected ? 'plus green' : 'minus red'}"></span> ${t.name}</li>`))
        }
        if (grouped.false) {
            if (grouped.true) {
                label += `et `
            }
            label += `retirer ${grouped.false.length} affectation(s) `
            _.each(grouped.false, (t) => (list += `<li><span class="fa fa-${t.selected ? 'plus green' : 'minus red'}"></span> ${t.name}</li>`))
        }
        label += `<br><ul>${list}</ul>`

        $scope.recapAffectation = {
            expl: {
                label,
                type: 'label',
            },
        }
    }

    $scope.affect = () => {
        const grouped = _.groupBy($scope.getDiff(), 'selected')
        $scope.affecting = true
        return DataAccess.modifyAccountAffectations({ id_account: user.id }, grouped).$promise.then(() => {
            AlertManager.success('Affectation modifiées')
            $scope.close()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.affecting = false
        })
    }

    $scope.selectAll = () => {
        _.each(getFiltered(), (f) => {
            f.selected = true
        })
    }

    $scope.selectNone = () => {
        _.each(getFiltered(), (f) => {
            f.selected = false
        })
    }

    // RETURN OK
    $scope.close = () => $uibModalInstance.close()

    $uibModalInstance.dismiss = $scope.ok
})
